import { useRef, useState } from "react";
import User from '../../../services/user';
import { useHistory } from 'react-router-dom';
import "./index.scss";

function AccountManage() {
  const ref = useRef();
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState();
  let history = useHistory()

	function logout(e) {
		e.preventDefault()
		User.logout()
		history.push('/')
	}

  function goToMyAccount(e){
    e.preventDefault()
    history.push('/account');
  }

  return (
    <div ref={ref} className="account-manage-dropdown">
      <div
        onMouseEnter={() => {
          if(timer) clearTimeout(timer);
          setOpen(true);
        }}
        onMouseLeave={() => {
          const newTimer = setTimeout(() => {
            setOpen(false);
          }, 3000);
          setTimer(newTimer);
        }}
        className="account-manage-toggle"
      >
        <i className="icon-account" />
      </div>
      {open && (
        <div
          onMouseEnter={() => {
            if (timer) {
              clearTimeout(timer);
              setTimer();
            }
          }}
          onMouseLeave={() => {
            setOpen(false);
          }}
          className="account-manage-dropdown-menu"
        >
          <div onClick={goToMyAccount} className="dropdown-item">Account</div>
          <div onClick={logout} className="dropdown-item">Logout</div>
        </div>
      )}
    </div>
  );
}

export default AccountManage;
